import React from 'react';
import { connect } from 'react-redux';
import Api from '../../api/Api.js';
import ServiceEndpoints from '../../api/ServiceEndpoints'; 
import { store } from '../../redux/store';
import { SET_SERVICE_LIST } from '../../redux/types';
import { push } from 'connected-react-router';
import { ServicesIcon } from '../../variables/dataIcons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DataTable from '../../components/Table/DataTable';

const columns = [
    {
        name: 'id',
        options: {
            filter: false,
            sort: false,
            download: false,
            print: false,
            display: "excluded"
        }
    },
    {
        name: "",
        options: {
            filter: false,
            sort: false,
            download: false
        }
    },
    {
        name: "Service Name",
        options: {
            filter: true,
            sort: true,
        }
    }
];



class SearchServices extends React.Component {

    options = {
        onRowClick: (row) => store.dispatch(push('/service/view/' + row[0]))
    };

    UNSAFE_componentWillMount() {
        Api.get(ServiceEndpoints.list).then(({ data }) => store.dispatch({ type: SET_SERVICE_LIST, payload: data })).catch((e) => console.error(e));
    }

    render() {
        return (
                <DataTable
                    title={"Search Services"}
                    data={
                        this.props.services
                        .map(serv => [serv.id, <FontAwesomeIcon icon={ServicesIcon} color={'green'} />, serv.name])
                    }
                    columns={columns}
                    options={this.options}
                />
        );
    }
}

const mapStateToProps = (state) => ({ services: state.services.list })

export default connect(mapStateToProps)(SearchServices);